import React from 'react'
import _get from 'lodash/get'
import { Redirect } from 'react-router-dom'
import store from '../../_common/redux/store'
import { ROLES } from '../constants/roles'
import { getPermissions } from '../_theme/utils'

const bulkInvoicePermission = C => props => {
  const globalStates = store.getState()
  const userRole = _get(globalStates, 'auth.user.tfRole')
  const event = _get(globalStates, 'events.selected')
  const user = _get(globalStates, 'auth.user')
  
  // Get the same flags used in menu visibility
  const flagShowBulkInvoices = _get(event, 'flagShowBulkInvoices', false)
  const flagIsStripePaymentMethod = _get(event, 'flagIsStripePaymentMethod', false)
  
  // Get permission flags
  const isTfSupport = ROLES.is_tf_support(userRole)
  const isTfSupportAdminOrClientAdmin = ROLES.is_tf_support_admin_or_client_admin(userRole)
  
  const eventRole = _get(event, 'self.role')
  const permissions = getPermissions(eventRole)
  const isAdminOrOwner = permissions.isAdminOrOwner()
  
  // Check if user has access based on the same logic as menu visibility
  const hasAccess = flagShowBulkInvoices && 
                   flagIsStripePaymentMethod && 
                   (isTfSupportAdminOrClientAdmin || isAdminOrOwner)
  
  // If no access, redirect to dashboard home
  if (!hasAccess) {
    return <Redirect to="/" />
  }
  
  return <C {...props} />
}

export const bulkInvoicePermissionWrapper = bulkInvoicePermission